export const eeoConfigs = [
  {
    componentReference: 'title',
    label: 'EEO',
    id: 'eeo-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
  },
  {
    containerType: 'eeoc',
    componentType: 'table',
    componentReference: 'table',
    id: 'eeoc_veteran_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Veteran status',
      id: 'eeoc_veteran_table',
      tableData: [
        {
          header: 'Decline To Answer',
          ds: [
            ['2', null, 0, 0, 1431, 649, 225, 53, 0],
            ['2', null, 0, 1, 1, 1, 1, 0, 0],
          ],
          dt: 0,
          g1: 0,
          g2: 0,
          applied: 1432,
          interviewed: 650,
          offered: 226,
          hired: 53,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 1431,
            interviewed: 649,
            offered: 225,
            hired: 53,
            rejected: 0,
          },
          Male: {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 1,
            applied: 1,
            interviewed: 1,
            offered: 1,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          columnTotal: {
            'Not Identified': {
              applied: 1435,
              interviewed: 649,
              offered: 225,
              hired: 53,
              rejected: 0,
            },
            Male: {
              applied: 5,
              interviewed: 3,
              offered: 2,
              hired: 0,
              rejected: 0,
            },
            Female: {
              applied: 1,
              interviewed: 1,
              offered: 1,
              hired: 1,
              rejected: 0,
            },
          },
          rowTotal: {
            applied: 1441,
            hired: 54,
          },
        },
        {
          header: 'Protected Veteran',
          ds: [['2', null, 1, 0, 4, 0, 0, 0, 0]],
          dt: 0,
          g1: 1,
          g2: 0,
          applied: 4,
          interviewed: 0,
          offered: 0,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 1,
            g2: 0,
            applied: 4,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Not Protected Veteran',
          ds: [
            ['2', null, 2, 1, 4, 2, 1, 0, 0],
            ['2', null, 2, 2, 1, 1, 1, 1, 0],
          ],
          dt: 0,
          g1: 2,
          g2: 0,
          applied: 5,
          interviewed: 3,
          offered: 2,
          hired: 1,
          rejected: 0,
          Male: {
            ds: '2',
            dt: 0,
            g1: 2,
            g2: 1,
            applied: 4,
            interviewed: 2,
            offered: 1,
            hired: 0,
            rejected: 0,
          },
          Female: {
            ds: '2',
            dt: 0,
            g1: 2,
            g2: 2,
            applied: 1,
            interviewed: 1,
            offered: 1,
            hired: 1,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
      ],
    },
    api: {
      subject_type: 'eeoc',
      metadata: {
        tileKey: 'eeoc_veteran_table',
        componentType: 'table',
        apiParam: 'visual',
        defaultFilters: {
          group_by_1: 'veteran_status',
          group_by_2: 'gender',
        },
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'eeoc_veteran_table',
      },
    },
  },
  {
    containerType: 'eeoc',
    componentType: 'table',
    componentReference: 'table',
    id: 'eeoc_disability_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Disability status',
      id: 'eeoc_disability_table',
      tableData: [
        {
          header: 'Decline To Answer',
          ds: [
            ['2', null, 0, 0, 1431, 649, 225, 53, 0],
            ['2', null, 0, 1, 4, 2, 2, 0, 0],
            ['2', null, 0, 2, 1, 1, 1, 1, 0],
          ],
          dt: 0,
          g1: 0,
          g2: 0,
          applied: 1436,
          interviewed: 652,
          offered: 228,
          hired: 54,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 1431,
            interviewed: 649,
            offered: 225,
            hired: 53,
            rejected: 0,
          },
          Male: {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 1,
            applied: 4,
            interviewed: 2,
            offered: 2,
            hired: 0,
            rejected: 0,
          },
          Female: {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 2,
            applied: 1,
            interviewed: 1,
            offered: 1,
            hired: 1,
            rejected: 0,
          },
          columnTotal: {
            'Not Identified': {
              applied: 1435,
              interviewed: 649,
              offered: 225,
              hired: 53,
              rejected: 0,
            },
            Male: {
              applied: 5,
              interviewed: 3,
              offered: 2,
              hired: 0,
              rejected: 0,
            },
            Female: {
              applied: 1,
              interviewed: 1,
              offered: 1,
              hired: 1,
              rejected: 0,
            },
          },
          rowTotal: {
            applied: 1441,
            hired: 54,
          },
        },
        {
          header: 'No Disability History',
          ds: [
            ['2', null, 1, 0, 3, 0, 0, 0, 0],
            ['2', null, 1, 1, 1, 1, 0, 0, 0],
          ],
          dt: 0,
          g1: 1,
          g2: 0,
          applied: 4,
          interviewed: 1,
          offered: 0,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 1,
            g2: 0,
            applied: 3,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          Male: {
            ds: '2',
            dt: 0,
            g1: 1,
            g2: 1,
            applied: 1,
            interviewed: 1,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Has Disability History',
          ds: [['2', null, 2, 0, 1, 0, 0, 0, 0]],
          dt: 0,
          g1: 2,
          g2: 0,
          applied: 1,
          interviewed: 0,
          offered: 0,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 2,
            g2: 0,
            applied: 1,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
      ],
    },
    api: {
      subject_type: 'eeoc',
      metadata: {
        tileKey: 'eeoc_disability_table',
        componentType: 'table',
        apiParam: 'visual',
        defaultFilters: {
          group_by_1: 'disability_status',
          group_by_2: 'gender',
        },
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'eeoc_disability_table',
      },
    },
  },
  {
    containerType: 'eeoc',
    componentType: 'table',
    componentReference: 'table',
    id: 'eeoc_race_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Race',
      id: 'eeoc_race_table',
      tableData: [
        {
          header: 'Not Identified',
          ds: [['2', null, 0, 0, 1424, 645, 223, 53, 0]],
          dt: 0,
          g1: 0,
          g2: 0,
          applied: 1424,
          interviewed: 645,
          offered: 223,
          hired: 53,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 1424,
            interviewed: 645,
            offered: 223,
            hired: 53,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          columnTotal: {
            'Not Identified': {
              applied: 1435,
              interviewed: 649,
              offered: 225,
              hired: 53,
              rejected: 0,
            },
            Male: {
              applied: 5,
              interviewed: 3,
              offered: 2,
              hired: 0,
              rejected: 0,
            },
            Female: {
              applied: 1,
              interviewed: 1,
              offered: 1,
              hired: 1,
              rejected: 0,
            },
          },
          rowTotal: {
            applied: 1441,
            hired: 54,
          },
        },
        {
          header: 'Decline To Answer',
          ds: [['2', null, 1, 0, 7, 4, 2, 0, 0]],
          dt: 0,
          g1: 1,
          g2: 0,
          applied: 7,
          interviewed: 4,
          offered: 2,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 1,
            g2: 0,
            applied: 7,
            interviewed: 4,
            offered: 2,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'White',
          ds: [
            ['2', null, 2, 0, 1, 0, 0, 0, 0],
            ['2', null, 2, 1, 1, 1, 0, 0, 0],
          ],
          dt: 0,
          g1: 2,
          g2: 0,
          applied: 2,
          interviewed: 1,
          offered: 0,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 2,
            g2: 0,
            applied: 1,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          Male: {
            ds: '2',
            dt: 0,
            g1: 2,
            g2: 1,
            applied: 1,
            interviewed: 1,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Native Hawaiian Or Other Pacific Islander',
          ds: [['2', null, 3, 0, 3, 0, 0, 0, 0]],
          dt: 0,
          g1: 3,
          g2: 0,
          applied: 3,
          interviewed: 0,
          offered: 0,
          hired: 0,
          rejected: 0,
          'Not Identified': {
            ds: '2',
            dt: 0,
            g1: 3,
            g2: 0,
            applied: 3,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Two Or More Races',
          ds: [['2', null, 4, 1, 1, 0, 0, 0, 0]],
          dt: 0,
          g1: 4,
          g2: 0,
          applied: 1,
          interviewed: 0,
          offered: 0,
          hired: 0,
          rejected: 0,
          Male: {
            ds: '2',
            dt: 0,
            g1: 4,
            g2: 1,
            applied: 1,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Asian',
          ds: [
            ['2', null, 5, 1, 2, 1, 1, 0, 0],
            ['2', null, 5, 2, 1, 1, 1, 1, 0],
          ],
          dt: 0,
          g1: 5,
          g2: 0,
          applied: 3,
          interviewed: 2,
          offered: 2,
          hired: 1,
          rejected: 0,
          Male: {
            ds: '2',
            dt: 0,
            g1: 5,
            g2: 1,
            applied: 2,
            interviewed: 1,
            offered: 1,
            hired: 0,
            rejected: 0,
          },
          Female: {
            ds: '2',
            dt: 0,
            g1: 5,
            g2: 2,
            applied: 1,
            interviewed: 1,
            offered: 1,
            hired: 1,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
        {
          header: 'Hispanic Or Latino',
          ds: [['2', null, 6, 1, 1, 1, 1, 0, 0]],
          dt: 0,
          g1: 6,
          g2: 0,
          applied: 1,
          interviewed: 1,
          offered: 1,
          hired: 0,
          rejected: 0,
          Male: {
            ds: '2',
            dt: 0,
            g1: 6,
            g2: 1,
            applied: 1,
            interviewed: 1,
            offered: 1,
            hired: 0,
            rejected: 0,
          },
          undefined: {
            ds: 0,
            dt: 0,
            g1: 0,
            g2: 0,
            applied: 0,
            interviewed: 0,
            offered: 0,
            hired: 0,
            rejected: 0,
          },
        },
      ],
    },
    api: {
      subject_type: 'eeoc',
      metadata: {
        tileKey: 'eeoc_race_table',
        componentType: 'table',
        apiParam: 'visual',
        defaultFilters: {
          group_by_1: 'race',
          group_by_2: 'gender',
        },
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'eeoc_race_table',
      },
    },
  },
];

export const eeoLayoutConfig = [
  {
    key: 'eeoc_race_table',
    x: 0,
    y: 0,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
  {
    key: 'eeoc_veteran_table',
    x: 0,
    y: 18,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
  {
    key: 'eeoc_disability_table',
    x: 0,
    y: 36,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
